module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2bm"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/pref"
    }
  }, [_vm._v("     PREFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 1")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“YELLOW-HAIRED LADDIE”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 2")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("WEST POINT")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch03"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 3")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("A BEGINNING")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch04"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 4")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("LIBBIE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 5")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“COME ON. YOU WOLVERINES”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 6")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“FIGHTING WAS HIS BUSINESS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 7")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“MY OWN BRIGHT PARTICULAR "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("STAR”")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 8")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("MARRIAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 9")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“WHERE IN HELL IS THE REAR?”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 10")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“DAUGHTER OF THE STARS”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 11")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("MAJOR GENERAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 12")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("“THE BEST CAVALRY GENERAL IN THE ARMY”")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 13")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("REC0NSTRUCTION SOLDIER")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 14")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("COURT-MARTIAL")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 15")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("WINTER WAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 16")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("NORTH TO DAKOTA")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 17")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("LAKOTA GOLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 18")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("TOWARD LITTLE BIG HORN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Chapter 19")]), _vm._v(" • "), _c('span', {
    staticClass: "txbf"
  }, [_vm._v("MONTANA HILL")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/photographs",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("PHOTOGRAPHS")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/biblo",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "contr"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0